export const awardHost = "https://germanwahnsinn.de/";
export const strapiHost = "https://cms.germanwahnsinn.de";
// export const strapiHost = "http://localhost:1337";
